import React, { FC } from 'react';

import { Link } from 'react-router-dom';

interface ConditionalBlockLinkProps {
  withLink: boolean;
  to?: string;
  className?: string;
}

const ConditionalBlockLink: FC<ConditionalBlockLinkProps> = ({ withLink, children, ...props }) => {
  return withLink ? (
    <Link {...props}>{children}</Link>
  ) : (
    <div className={props?.className || ''}>{children}</div>
  );
};

export default ConditionalBlockLink;
